<template>
  <el-dialog title="History Track" :close-on-click-modal="false" :visible.sync="visible" width="1100px" top="3vh">
    <div>
      <el-form class="el-form-filter" :inline="true" :model="dataForm" @submit.native.prevent="getDataList(1)">
        <el-form-item>
          <el-date-picker
            value-format="timestamp"
            v-model="watchStartToEndSecondTimeRange"
            type="daterange"
            range-separator="~"
            start-placeholder="Start Date"
            end-placeholder="Ending Date"
            @change="getDataList(1)"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="mt20 pb20">
      <el-table border :data="dataList" v-loading="dataListLoading" style="width: 100%">
        <el-table-column align="center" label="Status">
          <template slot-scope="scope">
            <p>{{ engagementStatusFormat(scope.row.status) }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Handling Time" width="164px">
          <template slot-scope="scope">
            {{ scope.row.createAt | parseTimeSecond }}
          </template>
        </el-table-column>
        <el-table-column prop="userInfo" align="center" label="Handler">
          <template slot-scope="scope">
            <span>{{ scope.row.userInfo.nickname }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" align="center" label="Reopen Reason / Remark" />
      </el-table>
      <!-- 分页 -->
      <pagination
        :current="current"
        :pageSize="pageSize"
        :totalCount="totalCount"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></pagination>
    </div>
  </el-dialog>
</template>

<script>
import Pagination from "@/components/Pagination";
import paginationMixin from "@/mixins/paginationMixin";
import searchMixin from "@/mixins/searchMixin";
import filtersMixin from "@/mixins/filtersMixin";
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [paginationMixin, searchMixin, filtersMixin, formatterMixin],
  components: { Pagination },
  data() {
    return {
      visible: false,
      dataList: [],
      dataListLoading: false,
      dataForm: {
        engagementId: null,
        startTime: "",
        endTime: "",
      },
      watchStartToEndSecondTimeRange: null,
    };
  },
  methods: {
    async init(id) {
      this.visible = true;
      await this.$nextTick();
      this.dataForm = {
        engagementId: id,
        startTime: "",
        endTime: "",
      };
      this.getDataList(1);
    },
    // 获取分页
    getDataList(current) {
      setTimeout(async () => {
        this.dataListLoading = true;
        if (current) {
          this.current = current;
        }
        const { code, data } = await this.$http.get("/admin/engagementLog/paging", {
          params: {
            current: this.current,
            size: this.pageSize,
            ...this.dataForm,
          },
        });
        if (code === 200) {
          this.dataList = data.records;
          this.totalCount = data.total;
        } else {
          this.dataList = [];
          this.totalCount = 0;
        }
        this.dataListLoading = false;
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped></style>
